var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItems(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.93935 9.49735L3.91602 4.66669H12.3333C12.7673 4.66669 13.0853 5.07402 12.98 5.49535L12.0813 9.09002C11.9447 9.63602 11.4807 10.0374 10.9207 10.0934L6.37668 10.548C5.69935 10.6154 5.08002 10.1627 4.93935 9.49735Z",
    stroke: "#8145B5",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.91567 4.66669L3.48234 2.66669H2.33301",
    stroke: "#8145B5",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4062 12.8446C11.2716 12.8446 11.1622 12.954 11.1636 13.0886C11.1636 13.2233 11.2729 13.3326 11.4076 13.3326C11.5422 13.3326 11.6516 13.2233 11.6516 13.0886C11.6509 12.954 11.5416 12.8446 11.4062 12.8446",
    stroke: "#8145B5",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.79816 12.8447C5.66349 12.8447 5.55416 12.954 5.55549 13.0887C5.55416 13.224 5.66416 13.3333 5.79883 13.3333C5.93349 13.3333 6.04283 13.224 6.04283 13.0893C6.04283 12.954 5.93349 12.8447 5.79816 12.8447",
    stroke: "#8145B5",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItems);
export default __webpack_public_path__ + "static/media/Items.712cdc0043618d841ee47fedb1992152.svg";
export { ForwardRef as ReactComponent };